// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cG","cardHeaderIcon__content":"c-e_cH"};